import { sum } from '../../helpers/array'
import { hasValue } from '../../helpers/nullable'
import { ItemVisitData, ViewItem } from './itemModel'

export type VisitSummary = {
  visitId: string
  date: string
  isReviewed: boolean
  quantity: number
  totalPrice: number
}

export const summarizeVisits = (visitData: ItemVisitData[], viewItems: ViewItem[]): VisitSummary[] => {
  return visitData.map(v => {
    const items = viewItems.filter(x => x.visit?.id === v.id)
    if (items.length === 0) {
      return undefined
    }

    const x: VisitSummary = {
      visitId: v.id,
      date: new Date(v.date).toLocaleDateString('en-US'),
      isReviewed: v.billed,
      quantity: sum(items, x => x.quantity),
      totalPrice: sum(items, x => x.totalPrice),
    }
    return x
  }).filter(x => hasValue(x)) as VisitSummary[]
}
